module.exports = __webpack_public_path__ + "img/step-1_m.ff8d347.jpg";